export function SuggestionCell({ suggestion, onConfirm, onDismiss }: { suggestion: { tax_line?: string; reason?: string; strength?: string } | null; onConfirm?: () => void; onDismiss?: () => void }) {
  if (!suggestion) return <span className="text-xs text-muted-foreground">No suggestion · ask owner</span>;
  return <span className="inline-flex items-center gap-2 text-xs"><span>Line {suggestion.tax_line ?? '—'}</span><button type="button" onClick={onConfirm}>Confirm</button><button type="button" onClick={onDismiss}>Dismiss</button></span>;
}

export default SuggestionCell;
